import React, { Component } from "react";
import { Form, Modal } from "antd";
import styles from "./index.less";
import FormCreate from "../../../../../../components/FormCreate/index";

const normTypeData = [
  {
    value: 1,
    label: "指标分组"
  },
  {
    value: 2,
    label: "指标详情"
  }
];
const { FormTextArea, FormSelect, FormTitle } = FormCreate;

@Form.create()
class AddNormModal extends Component {
  handleOk = () => {
    const { onOk, form } = this.props;
    const { validateFields } = form;
    validateFields((err, { type = 1, name = "", number = "" }) => {
      if (!err && onOk) {
        onOk({ type, name, number });
      }
    });
  };

  render() {
    const { title, form, onCancel, visible } = this.props;
    const { getFieldsValue } = form;

    const normType = getFieldsValue().type || '';
    const normNumber = getFieldsValue().number || '';
    const normName = getFieldsValue().name || '';

    const normTypeProps = {
      keyName: "type",
      optionData: normTypeData,
      isRequired: true,
      form,
      label: "模板类型",
      onChange: this.handleTypeChange,
      placeholder: "请选择模板类型"
    };

    const normNumberProps = {
      form,
      label: "指标编号",
      keyName: "number",
      maxLength: 10,
      suffix: `${(normNumber && normNumber.length) || 0}/10`
    };

    const normNameProps = {
      form,
      label: "名称",
      keyName: "name",
      maxLength: 100,
      rows:5,
      isRequired:true,
      suffix: `${(normName && normName.length) || 0}/100`
    };

    return (
      <Modal
        title={title}
        centered
        visible={visible}
        onOk={this.handleOk}
        onCancel={onCancel}
        okButtonProps={{
          disabled:
            !normType ||
            !normNumber.trim().length ||
            normNumber.trim().length > 10 ||
            !normName.trim().length ||
            normName.trim().length > 100
        }}
        wrapClassName={styles.addModal}
      >
        <FormCreate labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}>
          <FormSelect {...normTypeProps} />
          <FormTitle {...normNumberProps} />
          <FormTextArea {...normNameProps} />
        </FormCreate>
      </Modal>
    );
  }
}

export default AddNormModal;
